module.exports = __webpack_public_path__ + "static/media/pirateparrot.4777855a.gif";